import React from "react";

const ComponentWrapper = ({ children, styles }) => {
  return (
    <div className={`w-full ${styles}`}>
      <div className="w-full h-full max-w-[1150px] m-auto lg:px-8 px-4">
        {children}
      </div>
    </div>
  );
};

export default ComponentWrapper;
